import { useEffect, useState } from "react";
import { Building2, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export const COLOR_CO = { galpon: "#c8891a", silo: "#7c5cff", vivienda: "#38bdf8" };
const ETQ = { galpon: "Galpón / tinglado", silo: "Silo / depósito", vivienda: "Vivienda u otra chica" };

export function useConstrucciones(cod, padron) {
  const [c, setC] = useState(null);
  useEffect(() => {
    let vivo = true;
    setC(null);
    api.get("/portal/titulares/parcela/construcciones", { params: { cod, padron }, timeout: 260000 })
      .then((r) => vivo && setC(r.data)).catch((e) => vivo && setC({ error: formatApiErrorDetail(e?.response?.data?.detail) || "No disponible" }));
    return () => { vivo = false; };
  }, [cod, padron]);
  return c;
}

export function Construcciones({ c, ver, onVer }) {
  if (!c) return <div className="rounded-xl border border-[#eceeec] p-3 text-xs text-[#5f6f66] flex items-center gap-2" data-testid="parcela-construcciones-cargando">
    <Loader2 className="w-4 h-4 animate-spin" />Buscando construcciones…</div>;
  return <div className="rounded-xl border border-[#eceeec] p-3 space-y-2 text-xs" data-testid="parcela-construcciones">
    <div className="flex items-center gap-2"><Building2 className="w-4 h-4 text-[#c8891a]" /><p className="font-semibold text-sm text-[#13211b]">Construcciones</p>
      {c.n > 0 && <button onClick={onVer} className="ml-auto underline text-[#5f6f66]" data-testid="parcela-construcciones-ver">{ver ? "Ocultar en el mapa" : "Ver en el mapa"}</button>}</div>
    {c.error ? <p className="text-[#5f6f66]" data-testid="parcela-construcciones-error">{c.error}</p> : <>
      <p data-testid="parcela-construcciones-resumen">{c.n > 0 ? <><b>{c.n}</b> construcción/es · <b>~{(c.m2 || 0).toLocaleString("es-PY")} m²</b> construidos</> : "Sin construcciones detectadas dentro de la parcela."}</p>
      {c.n > 0 && <ul className="space-y-0.5">{Object.entries(c.tipos || {}).filter(([, v]) => v.n).map(([k, v]) => <li key={k} className="flex items-center gap-2" data-testid={`parcela-construcciones-${k}`}>
        <span className="w-2.5 h-2.5 rounded-sm" style={{ background: COLOR_CO[k] }} />{ETQ[k]} (estimado): {v.n} · {v.m2.toLocaleString("es-PY")} m²</li>)}</ul>}
      {c.limitrofes?.length > 0 && <p className="text-[#5f6f66]" data-testid="parcela-construcciones-limitrofes">{c.limitrofes.length} construcción/es sobre el límite con una vecina (no se suman): {c.limitrofes.map((x) => `${x.m2} m², ${x.pct_dentro}% adentro`).join(" · ")}</p>}
    </>}
    <p className="text-[10px] text-[#5f6f66]" data-testid="parcela-construcciones-nota">Detección por IA sobre imágenes 2014–2021. Estimado, no incluye construcciones posteriores a 2021. Confirmar en terreno.</p>
  </div>;
}
